<template>
  <bizgain-component-layout
    :is-next-btn-enabled="true"
    :is-content-top="true"
    :col-width="{
      'mx-5 px-4': !$vuetify.breakpoint.xsOnly,
      'mx-2': $vuetify.breakpoint.xsOnly
    }"
    :view-port-height="animationType > 0 ? '200px' : '170px'"
  >
    <template v-slot:heading>
      <!-- {{ $t('message.bizgainOnboarding.businessDetailsHeadingv2') }} -->
      <span v-if="animationType == 0">
        {{ $t('message.bizgainOnboarding.businessInfoHeading') }}
      </span>
    </template>
    <template v-slot:content>
      <v-flex v-if="animationType===0" xs12 class="business-location-details">
        <v-card class="pa-3 mb-1">
          <v-flex :class="[{'d-flex': !$vuetify.breakpoint.xsOnly}]">
            <v-flex xs12 md6 v-if="!isInAppCampaign">
              <custom-text-field
                :placeholder="$tc('message.bizgainOnboarding.businessName')"
                :classes="['pt-0 mt-0',{'pr-2':!$vuetify.breakpoint.xsOnly}]"
                :name="'businessName'"
                :counter="'25'"
                v-model="businessName"
                :autocapitalize="'off'"
                :validation="'required|max:25|emojiValidation'"
                :icon="'mdi-check'"
              />
            </v-flex>
            <v-flex
              v-if="!isInAppCampaign"
              xs12
              md5
              :class="[{'pl-2': !$vuetify.breakpoint.xsOnly, 'pt-3': $vuetify.breakpoint.xsOnly}]"
            >
              <business-type
                :is-summary="false"
                :hide-business-type-label="true"
                @save-businessType="updateBusinessType"
              />
            </v-flex>
          </v-flex>
          <v-flex :class="[{'d-flex pt-3': !$vuetify.breakpoint.xsOnly}]">
            <v-flex xs12 md6 v-if="!isInAppCampaign">
              <v-flex xs12 :class="[{'setup-business-info-logo': triggerValidations && !(logoDetails && logoDetails.url)}]">
                <image-picker
                  :items="logos"
                  :type="imageTypes.logo"
                  :loader="hasLogoChanged"
                  :selected-template-id="selectedTemplateId"
                  :disabled="hasLogoChanged"
                  @update="updateLogo"
                  @uploadedLogos="addLogos"
                  @image-process="processImage"
                  :is-lead-image="false"
                />
              </v-flex>
              <v-flex xs12 class="pt-2 pl-1" v-if="triggerValidations && !(logoDetails && logoDetails.url)">
                <div class="v-messages error--text">
                  {{ $tc('message.bizgainOnboarding.logoRequired') }}
                </div>
              </v-flex>
            </v-flex>
            <v-flex
              v-if="!isInAppCampaign"
              xs12
              md5
              :class="[{'pl-2': !$vuetify.breakpoint.xsOnly, 'pt-3': $vuetify.breakpoint.xsOnly}]"
            >
              <v-flex
                xs12
                :class="[{'setup-business-info-color': triggerValidations && !color}]"
              >
                <v-layout
                  class="input-border justify-space-between"
                  :class="'color-picker-container'"
                  @click=" colorPicker.show()"
                >
                  <v-flex
                    class="shrink"
                    pl-1
                    my-1
                  >
                    <div
                      class="color-picker"
                      :id="'color-picker'"
                      :style="{ 'background-color': color }"
                    />
                  </v-flex>
                  <v-flex
                    xs5
                    sm4
                    md5
                    py-1
                    class="color-picker-code body-1"
                    :class="{'pl-3': $vuetify.breakpoint.xsOnly, 'ml-2': $vuetify.breakpoint.smAndUp, 'ml-1': $vuetify.breakpoint.mdOnly, 'ml-4': $vuetify.breakpoint.lgAndUp}"
                  >
                    <span class="truncate"> {{ textTruncate(color, 20) }} </span>
                  </v-flex>
                  <v-divider
                    :class="{'ml-1': $vuetify.breakpoint.xsOnly, 'ml-2': $vuetify.breakpoint.smAndUp}"
                    inset
                    vertical
                  />
                  <v-layout
                    align-center
                    justify-center
                    :class="{'pr-3 ml-1': $vuetify.breakpoint.xsAndDown, 'mr-4': $vuetify.breakpoint.smAndDown, 'pr-0': $vuetify.breakpoint.smAndUp, 'pr-4': $vuetify.breakpoint.mdAndUp, 'pr-4': $vuetify.breakpoint.lgAndUp}"
                  >
                    <v-flex
                      xs6
                      sm7
                      md6
                      class="mr-2"
                    >
                      <span
                        flat
                        solo
                        v-ripple="false"
                        class="no-background-hover pa-0 modal-text"
                      >
                        <v-icon :color="'primary'" dense>
                          palette
                        </v-icon>
                        <span class="pl-1 pr-3" :class="'text-primary'">
                          {{ $t('message.bizgainOnboarding.change') }}
                        </span></span>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-flex>
              <v-flex xs12 class="pt-2 pl-1" v-if="triggerValidations && !color">
                <div class="v-messages error--text">
                  {{ $tc('message.bizgainOnboarding.colorRequired') }}
                </div>
              </v-flex>
            </v-flex>
          </v-flex>
        </v-card>
        <v-layout>
          <v-flex
            sm12
            xs12
            md12
            class="mb-1 full-height pt-2"
          >
            <v-layout
              v-if="extractedCreativeDetails"
              fill-height
              :class="['justify-center align-center',{'elevation-3 px-2 py-3':$vuetify.breakpoint.mdAndUp}]"
            >
              <v-flex
                xs12
                grow
              >
                <v-layout>
                  <v-flex>
                    <v-layout>
                      <v-flex lg7 md5 xs12>
                        <span class="ml-1 label">
                          {{ $tc('message.bizgainOnboarding.fbinstaAdPreview') }}
                        </span>
                      </v-flex>
                      <v-flex
                        lg3
                        md4
                        class="editIconContainer"
                        v-if="!$vuetify.breakpoint.xsOnly"
                      >
                        <CreativesV2 @setTemplateId="setTemplateId" :creative-templates="creativeDetail.templates">
                          <span style="margin: 0 auto;">
                            <v-icon class="editIcon">
                              auto_fix_normal
                            </v-icon>
                            <span class="label editIcon" v-show="$vuetify.breakpoint.mdAndUp">
                              {{ $tc('message.bizgainOnboarding.pickNewDesign') }}
                            </span>
                          </span>
                        </CreativesV2>
                      </v-flex>
                      <v-flex
                        lg2
                        md4
                        class="editIconContainer"
                        v-if="!$vuetify.breakpoint.xsOnly"
                      >
                        <edit-buttons :id="selectedTemplateId">
                          <span style="margin: 0 auto;">
                            <v-icon class="editIcon">
                              edit
                            </v-icon>
                            <span class="label editIcon" v-show="$vuetify.breakpoint.mdAndUp">
                              Edit Ads
                            </span>
                          </span>
                        </edit-buttons>
                      </v-flex>
                    </v-layout>
                    <v-layout v-if="$vuetify.breakpoint.xsOnly">
                      <v-flex xs6 grow>
                        <CreativesV2 @setTemplateId="setTemplateId">
                          <v-btn
                            class="mt-2 button-bg"
                            block
                            flat
                            color="primary font-weight-bold"
                          >
                            <v-icon>auto_fix_normal</v-icon>
                            {{ $tc('message.bizgainOnboarding.pickNewDesign') }}
                          </v-btn>
                        </CreativesV2>
                      </v-flex>
                      <v-flex xs6 class="pl-2" grow>
                        <edit-buttons :id="selectedTemplateId">
                          <v-btn
                            class="mt-2 button-bg"
                            block
                            flat
                            color="primary font-weight-bold"
                          >
                            <v-icon>edit</v-icon>
                            Edit Ads
                          </v-btn>
                        </edit-buttons>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <facebook-instagram-ad-preview
                  :facebook-ad-details="facebookAdDetails"
                  :extracted-creative-details="extractedCreativeDetails"
                  :template="template"
                  :show-facebook-preview="true"
                  :show-instagram-preview="true"
                />
              </v-flex>
            </v-layout>
            <v-layout v-if="extractedCreativeDetails">
              <v-flex
                xs12
                grow
                :class="['justify-center align-center',{'elevation-3 px-2 py-3 mt-3':$vuetify.breakpoint.mdAndUp}]"
              >
                <v-layout class="label">
                  <v-layout>
                    <v-flex xs10>
                      <span class="ml-1 label">
                        {{ $tc('message.bizgainOnboarding.googlead') }}
                      </span>
                    </v-flex>
                    <v-flex
                      xs2
                      class="editIconContainer"
                      v-if="!$vuetify.breakpoint.xsOnly"
                      @click="editGoogleText()"
                    >
                      <span style="margin: 0 auto;">
                        <v-icon class="editIcon">
                          edit
                        </v-icon>
                        <span class="label editIcon" v-show="$vuetify.breakpoint.mdAndUp">
                          Edit Ads
                        </span>
                      </span>
                    </v-flex>
                  </v-layout>
                </v-layout>
                <v-layout grow v-if="$vuetify.breakpoint.xsOnly">
                  <v-flex xs12 grow>
                    <v-btn
                      class="mt-2 button-bg"
                      block
                      flat
                      color="primary font-weight-bold"
                      @click="editGoogleText"
                    >
                      <v-icon>edit</v-icon> Edit Ads
                    </v-btn>
                  </v-flex>
                </v-layout>
                <GoogleAdPreviewV2 />
              </v-flex>
            </v-layout>
            <v-layout fill-height v-else class="justify-center align-center">
              <v-progress-circular
                :size="70"
                :width="4"
                color="primary"
                class="justify-center progress-circular"
                indeterminate
              />
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-container v-else-if="animationType===2">
        <v-layout
          row
          wrap
          justify-center
          align-center
        >
          <v-flex
            xs12
            class="d-flex align-center justify-center"
          >
            <v-card flat>
              <v-card-text class="pa-0" v-if="animationWidth && animationHeight">
                <div class="image-container">
                  <v-img
                    eager
                    :src="websiteScreenshot"
                    class="scanner-image ma-auto"
                    cover
                  />
                  <div class="scanner-line" />
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex
            xs12
            class="pt-3"
          >
            <span class="grey--text body-1 text-xs-center">{{ $t('message.bizgainOnboarding.businessInfoExtraction') }}</span>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container v-else class="mx-0 my-3 pa-0 w-100">
        <v-layout
          row
          wrap
          justify-center
          align-center
        >
          <v-flex
            xs12
          >
            <v-card flat>
              <v-card-text class="pa-0" v-if="animationWidth && animationHeight">
                <lottie-animation
                  :loop="lottieOptions.loop"
                  :autoplay="lottieOptions.autoplay"
                  :height="animationHeight"
                  :width="animationWidth"
                  :path="animationPath"
                />
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex
            xs12
          >
            <span class="grey--text body-1 text-xs-center">{{ $t('message.bizgainOnboarding.businessInfoExtraction') }}</span>
          </v-flex>
        </v-layout>
      </v-container>
    </template>
    <template v-slot:btn-content>
      <v-flex xs12 v-if="animationType == 0">
        <v-layout :class="{ 'column reverse': $vuetify.breakpoint.xsOnly }">
          <v-flex
            :class="{
              'shrink nxt-btn-margin mt-0': !$vuetify.breakpoint.xsOnly,
              xs12: $vuetify.breakpoint.xsOnly,
              'pl-2': $vuetify.breakpoint.smOnly
            }"
          >
            <v-btn
              depressed
              class="mx-0 w-100 next-btn-color primary-btn-xs"
              :loading="isLoading"
              :disabled="buttonDisabled || errors.items.length > 0"
              @click="submit"
            >
              {{ $t('message.bizgainOnboarding.LaunchMyAds') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </template>
  </bizgain-component-layout>
</template>
<script>
import {
  VFlex,
  VBtn,
  VLayout,
  VContainer,
  VCard,
  VCardText,
  VIcon,
  VDivider,
  VProgressCircular,
  VImg
} from 'vuetify/lib';
import BizgainComponentLayout from 'Components/BizgainComponentLayout/BizgainComponentLayout.vue';
import { mapActions, mapGetters } from 'vuex';
import clearErrorByField from 'Mixins/clearErrorByField';
import {
  bizgainOnboardingRoutes, objectiveType, privacyPolicyDataAccessTypes, launchState, adAccountSetupAnimationPath, imageTypes, offerType
} from 'Features/bizgainOnboarding/constants';
import { Chat } from 'Mixins/chat';
import Bugsnag from '@bugsnag/js';
import { Validator } from 'vee-validate';
import onboardingRedirect  from 'Mixins/onboardingRedirect';
import BusinessType from 'Components/BusinessType/BusinessType.vue';
import { i18n } from '@/lang/';
import CustomTextField from '../../../../../components/Input/CustomTextField.vue';
import { ApiService } from 'Features/bizgainOnboarding/services/apiService';
import LottieAnimation from 'lottie-vuejs/src/LottieAnimation.vue';
import ImagePicker from '../../imageCreativesCreativeEdit/components/ImagePicker.vue';
import CreativesV2 from '../../imageCreatives/components/CreativesV2.vue';
import EditButtons from '../../imageCreativesAdPreview/components/EditButtons.vue';
import FacebookInstagramAdPreview from '../../imageCreativesAdPreview/components/FacebookInstagramAdPreview.vue';
import GoogleAdPreviewV2 from '../../googleAdsPreview/components/GoogleAdPreviewV2.vue';
import uuidv4 from 'uuid/v4';
import debounce from 'lodash.debounce';
import { textTruncate } from 'Helpers/helpers';
import { generateFacebookAdDetails } from 'Features/bizgainOnboarding/helpers/templateHelper';
import '../../../js/pickr.min.js';
import '../../../css/pickr.nano.min.css';
// import ExtractOfferDetailsV2 from '../../offerDetails/components/ExtractOfferDetailsV2.vue';
const apiService = new ApiService();

export default {
  mixins: [clearErrorByField, Chat, onboardingRedirect],
  components: {
    VFlex,
    VBtn,
    VLayout,
    VContainer,
    VCardText,
    VProgressCircular,
    VCard,
    VDivider,
    VIcon,
    VImg,
    BizgainComponentLayout,
    BusinessType,
    CustomTextField,
    LottieAnimation,
    ImagePicker,
    CreativesV2,
    EditButtons,
    FacebookInstagramAdPreview,
    GoogleAdPreviewV2
    // ExtractOfferDetailsV2,
  },
  destroyed () {
    window.removeEventListener('wheel', this.hideColorPicker);
  },
  data() {
    return {
      animationType: 1,
      websiteScreenshot: null,
      lottieOptions: {
        loop: true,
        autoplay: false
      },
      animationPath: adAccountSetupAnimationPath.personalizedAds,
      businessName: null,
      creativeDetail: null,
      logoDetails: null,
      color: this.$vuetify.theme.white,
      colorPicker: null,
      setColorDebounced: null,
      extractedCreativeDetails: null,
      bizgainOnboardingRoutes,
      businessType: null,
      formFields: [],
      privacyPolicyDataAccessTypes,
      offerDetail: null,
      isValidOfferDetails: false,
      isLoading: false,
      promotionCopy: null,
      template: null,
      templateId: 0,
      facebookAdDetails: null,
      imageTypes,
      textTruncate,
      triggerValidations: false
    };
  },
  computed: {
    ...mapGetters([
      'currencySymbol',
      'region',
      'businessDetails',
      'isInAppCampaign',
      'businessProfileId',
      'roimaticCampaignId',
      'additionalConfiguration',
      'creativeLogos',
      'creativeLoader',
      'creativeLeadImages',
      'creativeImages'
    ]),
    buttonDisabled(){
      if(!this.businessType || !this.businessName || !this.color || !this.logoDetails || !this.logoDetails.url){
        return true;
      }
      return false;
    },
    animationWidth(){
      switch(this.$vuetify.breakpoint.name){
        case 'xs': return 250;
        case 'sm': return 300;
        case 'md': return 350;
        case 'lg':
        case 'xl': return 373;
        default: return 373;
      }
    },
    animationHeight(){
      switch(this.$vuetify.breakpoint.name){
        case 'xs': return 180
        case 'sm': return 190
        case 'md': return 200
        case 'lg':
        case 'xl': return 210
        default: return 210;
      }
    },
    logos() {
      if (this.creativeLogos && Array.isArray(this.creativeLogos[this.selectedTemplateId]) && this.creativeLogos[this.selectedTemplateId].length > 0) {
        return this.creativeLogos[this.selectedTemplateId].map(x => x.image);
      }
      return [];
    },
    hasLogoChanged(){
      return this.creativeLoader && this.creativeLoader.hasOwnProperty('logo');
    },
    selectedTemplateId() {
      return (this.creativeDetail && this.creativeDetail.selectedTemplateId) || 0;
    }
  },
  async created() {
    if(!this.$route.query.agentid && localStorage.getItem('isAgentFlow')){
      localStorage.removeItem('isAgentFlow');
    }

    const dict = {
      custom: {
        businessName: {
          max: this.$t(
            'message.bizgainOnboarding.businessNameValidationMessage'
          )
        }
      }
    };

    Validator.localize('en', dict);
    Validator.extend('emojiValidation', {
      getMessage: () =>
        this.$t('message.bizgainOnboarding.specialCharacterValidation'),
      validate: (value) => {
        return this.validateBusinessName(value);
      }
    });

    this.setCurrentRoute(bizgainOnboardingRoutes.SetupBusinessInfo.name);
  },
  watch: {
    businessName(value) {
      if (value && this.animationType == 0){
        this.updateBusinessNameReferences(value);
      }
    }
  },
  methods: {
    ...mapActions([
      'setCurrentRoute',
      'getBusinessDetails',
      'setSignUpSteps',
      'setSubsequentSteps',
      'patchAdditionalConfiguration',
      'setCurrentSection',
      'setBusinessDetails',
      'updateOfferDetails',
      'creativeConfiguration',
      'patchBusinessDetails',
      'updateCreativeLoader',
      'addCreativeLogo',
      'addCreativeLeadImage',
      'updateBusinessDetails',
      'setIsAutoGeneratedFlow'
    ]),
    hideColorPicker () {
      /*
          Post tab switch - On scroll the dialog position values which are updated to correct values are overrided by
          the library constructor to the position values which is incorrect, due to which on scroll dialog is
          repositioned to page's top left, hiding the element to prevent this behaviour.
          Note: There is a prop in the library which does the same thing but there is some noticeable delay
          Reference: https://github.com/Simonwep/pickr/blob/master/src/js/pickr.js
      */
      this.colorPicker.hide();
    },
    setFormFields(selectedFields){
      this.formFields = selectedFields;
    },
    setOfferDetails(offerDetails, isValidOfferDetails){
      this.isValidOfferDetails = isValidOfferDetails;
      this.offerDetail = offerDetails;
    },
    async submit() {
      this.triggerValidations = true;
      this.isLoading = true;
      let isValid = await this.$validator.validate();
      isValid = isValid && this.logoDetails && this.logoDetails.url && this.color;
      if(isValid){
        try{
          let newLaunchState = this.isInAppCampaign ? launchState.BUDGET : launchState.SIGNUP;
          let newBusinessDetails = this.getUpdateRequest();

          newBusinessDetails.launchState = newLaunchState;

          await this.updateUserProperties({ creativeUrl: newBusinessDetails.creativeDetail.creativeUrl, businessName: this.businessName, businessType: this.businessType, objectiveType: i18n.tc(objectiveType.leadGeneration.conversionTitle) });
          await this.redirect({ isAppFlow: true }, { isAppFlow: true, ...this.$route.params }, false, newLaunchState, newBusinessDetails);
        }
        catch(error){
          Bugsnag.notify(error);
        }
        finally{
          this.isLoading = false;
        }
      }
      this.isLoading = false;
    },
    getUpdateRequest(){
      let newBusinessDetails = JSON.parse(JSON.stringify(this.businessDetails));
      let creativeUrl = this.creativeImages.find(creativeImage=>creativeImage.templateId == this.selectedTemplateId).canvasImage.replace(/scaleFactor=[0-9.]+/, 'scaleFactor=1');

      newBusinessDetails.name = this.businessName;
      newBusinessDetails.category = { ...newBusinessDetails.category, ...this.businessType.value };

      newBusinessDetails.logoDetails = this.logoDetails;
      newBusinessDetails.isBusinessLogoAvailable = true;

      newBusinessDetails.creativeDetail = this.creativeDetail;
      newBusinessDetails.creativeDetail.selectedColorPalette.primaryColor = this.color;
      newBusinessDetails.creativeDetail.creativeUrl = creativeUrl;
      newBusinessDetails.creativeDetail.selectedTemplateId = this.selectedTemplateId;
      return newBusinessDetails;
    },
    async updateBsinessDetailsInDb(newBusinessDetails){
      if(!newBusinessDetails){
        newBusinessDetails = this.getUpdateRequest();
      }

      let patchBusinessDetailsPayload = {
        sessionId: this.businessDetails.sessionId,
        oldBusinessDetails: this.businessDetails,
        newBusinessDetails: newBusinessDetails
      };
      await this.patchBusinessDetails(patchBusinessDetailsPayload);
    },
    async generateCreatives(){
      try{
        let creativeDetail = await apiService.creativeConfiguration({ sessionId: this.businessDetails.sessionId, objective: 2, isAsync: false });
        let newBusinessDetails = JSON.parse(JSON.stringify(this.businessDetails));
        newBusinessDetails.creativeDetail = creativeDetail;

        // Selected First Template if default is not provided.
        if (creativeDetail && !creativeDetail.selectedTemplateId && creativeDetail.templates && creativeDetail.templates.length > 0){
          newBusinessDetails.creativeDetail.selectedTemplateId = creativeDetail.templates[0].id;
        }

        newBusinessDetails.creativeDetail.objective = 2;
        newBusinessDetails.launchState = launchState.BusinessDetailsSetupAnimationV2; // Later change to a new status
        newBusinessDetails.CurrencySymbol = this.currencySymbol;

        let dataTypes = []
        for (let dataType in this.privacyPolicyDataAccessTypes) {
          dataTypes.push(this.privacyPolicyDataAccessTypes[dataType].value);
        }

        if (newBusinessDetails.creativeDetail.leadAdConfiguration.hasOwnProperty('privacyPolicyConfiguration')){
          newBusinessDetails.creativeDetail.leadAdConfiguration.privacyPolicyConfiguration.dataAccessTypes = dataTypes;
        }
        else{
          newBusinessDetails.creativeDetail.leadAdConfiguration.privacyPolicyConfiguration = dataTypes;
        }

        if(newBusinessDetails){
          newBusinessDetails.launchState = launchState.BusinessDetailsV2;
          await this.updateBsinessDetailsInDb(newBusinessDetails);
        }
      }
      catch(error){
        Bugsnag.notify(error);
      }
    },
    validateBusinessName(value) {
      // this is regex for emoji detection. https://stackoverflow.com/questions/10992921/how-to-remove-emoji-code-using-javascript
      if (
        !value.match(
          /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g
        )
      ) {
        return true;
      }
      return false;
    },
    updateBusinessNameReferences(value){
      this.facebookAdDetails.pageName = value;
      this.creativeDetail.adDetail.textAd.businessName = value;
      this.creativeDetail.templates.forEach(template => {
        template.adDetail.textAd.businessName = value;
      });
      this.extractedCreativeDetails = this.extractCreativeDetails();
    },
    updateBusinessType(value){
      this.businessType = value;
      if(value.value.presetData && value.value.presetData.promotionCopy){
        this.promotionCopy = value.value.presetData.promotionCopy;
      }
      else{
        this.promotionCopy = `Best ${value.value.displayName}`;
      }
    },
    async updateLogo(item){
      let creativeLogos = this.creativeLogos;
      this.updateCreativeLoader({ logo: true });
      this.logoDetails = item;

      let selectedCreativeLogo;
      // eslint-disable-next-line no-unused-vars
      for(const [key, value] of Object.entries(creativeLogos)) {
        selectedCreativeLogo = value.find(x => x.image.uniqueId == item.uniqueId);
        if (selectedCreativeLogo && selectedCreativeLogo.image) {
          this.updateLogoDetails(selectedCreativeLogo.image, selectedCreativeLogo.id);
        }
      }
      this.updateCreativeDetail(selectedCreativeLogo);
    },
    async updateLogoDetails(item, creativeId) {
      let businessCreativeTemplate = this.creativeDetail.templates.find(x => x.id == creativeId);
      if (businessCreativeTemplate) {
        if (!businessCreativeTemplate.logo){
          businessCreativeTemplate.logo = {};
          businessCreativeTemplate.logo.dimension = {};
        }
        businessCreativeTemplate.logo.url = item.url;
        businessCreativeTemplate.logo.dimension.height = item.height;
        businessCreativeTemplate.logo.dimension.width = item.width;
      }
    },
    updateCreativeDetail(item) {
      this.logoDetails = item.originalLogoDetails;
      this.creativeDetail.suggestedColorPalettes = item.suggestedColorPalettes;
      this.creativeDetail.selectedColorPalette = item.selectedColorPalette;
      this.creativeDetail.templates = this.creativeDetail.templates.map(template => {
        return { ...template, colorPalette: item.selectedColorPalette, suggestedColorPalettes: item.suggestedColorPalettes, logo: { url: item.url, dimension: { width: item.width, height: item.height } } }
      });
      this.template = this.creativeDetail.templates.find(template => template.id == item.id);
      this.extractedCreativeDetails = this.extractCreativeDetails();
      this.facebookAdDetails = { ...this.facebookAdDetails, logo: item.url };
      if (this.colorPicker){
        this.colorPicker.setColor(item.selectedColorPalette.primaryColor);
      }

      this.$nextTick(() => {
        this.updateBsinessDetailsInDb(null);
      });
    },
    async addLogos(item) {
      let creativeLogos = JSON.parse(JSON.stringify(this.creativeLogos));
      if (item) {
        let logoDetail = {
          id: item.id,
          image: {
            height: item.height,
            name: item.name,
            uniqueId: item.uniqueId,
            url: item.url,
            width: item.width,
            type: item.type
          },
          originalLogoDetails: item.originalLogoDetails,
          selectedColorPalette: item.selectedColorPalette,
          suggestedColorPalettes: item.suggestedColorPalettes
        };
        if (creativeLogos[logoDetail.id]) {
          creativeLogos[logoDetail.id].unshift(logoDetail);
        } else {
          creativeLogos[logoDetail.id] = [];
          creativeLogos[logoDetail.id].unshift(logoDetail);
        }
        this.updateLogoDetails(logoDetail.image, logoDetail.id);
        this.updateCreativeDetail(item);
      }
      this.addCreativeLogo(creativeLogos);
    },
    processImage(value){
      this.$emit('isBtnDisabled', value);
    },
    setLeadImages(items) {
      let leadImages = JSON.parse(JSON.stringify(this.creativeLeadImages));
      for (let i = 0; i < items.length; i++) {
        let existingLeadImage = leadImages.find(cli => cli.name === items[i].name);
        if (!existingLeadImage) {
          leadImages.unshift(items[i]);
        }
      }
      this.addCreativeLeadImage(leadImages);
    },
    setTemplateId(templateId){
      this.templateId = templateId;
      this.template = this.creativeDetail.templates.find((x) => x.id == templateId);
      this.creativeDetail.selectedTemplateId = templateId;
      this.facebookAdDetails = generateFacebookAdDetails(this.businessDetails);
      this.extractedCreativeDetails = this.extractCreativeDetails(this.businessDetails);
    },
    extractCreativeDetails(){
      return { mobileNumber: this.businessDetails.mobileNumber, ...this.creativeDetail }
    },
    async editGoogleText(){
      let newBusinessDetails = JSON.parse(JSON.stringify(this.businessDetails));
      if(this.isInAppCampaign){
        await this.redirect({ id: this.selectedTemplateId, isAppFlow: true }, { id: this.selectedTemplateId, isAppFlow: true, ...{ ...this.$route.params, id: this.selectedTemplateId } }, 3, launchState.GOOGLEADEDIT, newBusinessDetails);
      }else{
        newBusinessDetails.creativeDetail.selectedTemplateId = this.selectedTemplateId;
        await this.redirect({ isAppFlow: true }, { isAppFlow: true, ...this.$route.params }, 3,  launchState.GOOGLEADEDIT, newBusinessDetails);
      }
    },
    async getWebsiteScreenshot(website){
      try{
        var response = await apiService.extractWebsiteScreenshot(this.$route.query.website);
        return response;
      }
      catch (ex){
        return null;
      }
    }
  },
  async mounted(){
    this.animationType = 1;
    this.setIsAutoGeneratedFlow(true);
    try{
      if(!(this.businessDetails && this.businessDetails.name) && this.$route.query.website){
        // Uncomment to activate screenshot loader
        /*
        _ = this.getWebsiteScreenshot(this.$route.query.website)
          .then(snapshot => {
            if (snapshot) {
              this.websiteScreenshot = snapshot;
              this.animationType = 2;
            }
          });
        */

        let payload = {
          websiteUrl: this.$route.query.website,
          region: this.region,
          queryParameters: this.$route.query,
          shortenFlow: true
        }
        await this.setBusinessDetails(payload);

        await this.generateCreatives();

        var offerMessage = 'Best Solution';
        if (this.businessDetails && this.businessDetails.category && this.businessDetails.category.displayName)
        {
          offerMessage = `Best ${this.businessDetails.category.displayName}`;
        }
        await this.updateOfferDetails({ businessDetails: this.businessDetails, offerDetail: { type: offerType.skip, customOffer: offerMessage }, sessionId: this.businessDetails.sessionId })
      }

      if(this.businessDetails && this.businessDetails.name){
        this.businessName = this.businessDetails.name;
      }
      if(this.businessDetails && this.businessDetails.logoDetails){
        this.logoDetails = this.businessDetails.logoDetails;
      }
      if(this.businessDetails && this.businessDetails.creativeDetail){
        this.creativeDetail = this.businessDetails.creativeDetail;
        if (this.businessDetails.creativeDetail.leadAdConfiguration){
          this.formFields = this.businessDetails.creativeDetail.leadAdConfiguration.formFields;
        }
      }

      this.template = this.creativeDetail.templates.find((x) => x.id == this.selectedTemplateId);
      let creativeDetail = this.creativeDetail;
      if (this.creativeLogos && Object.entries(this.creativeLogos).length == 0) {
        let uniqueId = uuidv4();
        if (this.template.logo && this.template.logo.url){
          let logoItem = {
            id: this.template.id,
            type: imageTypes.logo,
            name: this.template.logo.url.split('/').pop(),
            url: this.template.logo.url,
            suggestedColorPalettes: this.template.suggestedColorPalettes,
            selectedColorPalette: this.template.colorPalette,
            width: this.template.logo.dimension.width,
            height: this.template.logo.dimension.height,
            uniqueId,
            originalLogoDetails: this.logoDetails
          };
          this.$nextTick(async () => {
            await this.addLogos(logoItem);
          });
        }
      }

      var creativeTemplates = creativeDetail.templates.filter(template => template.leadImage && template.leadImage.url);
      if (Array.isArray(this.creativeLeadImages) && this.creativeLeadImages.length == 0) {
        let leadImages = creativeTemplates.map(template => {
          return {
            id: template.id,
            type: imageTypes.lead,
            name: template.leadImage.url.split('/').pop(),
            url: template.leadImage.url
          }
        })
        this.$nextTick(() => {
          this.setLeadImages(leadImages);
        })
      }
      this.extractedCreativeDetails = this.extractCreativeDetails();
      this.facebookAdDetails = generateFacebookAdDetails(this.businessDetails);

      this.animationType = 0;
      this.$nextTick(async () => {
        this.color = this.creativeDetail.templates.find((x) => x.id == this.template.id).colorPalette.primaryColor;
        this.colorPicker = Pickr.create({
          el: '#color-picker',
          theme: 'nano',
          useAsButton: true,
          position: 'right-start',
          lockOpacity: true,
          default: this.color,
          components: {
            // Main components
            preview: true,
            opacity: true,
            hue: true,

            // Input / output Options
            interaction: {
              hex: true,
              hsla: false,
              hsva: false,
              cmyk: false,
              input: true,
              clear: false,
              save: false
            }
          }
        });
        this.colorPicker.on('change', (color, instance) => {
          if(this.setColorDebounced){
            this.setColorDebounced.cancel();
          }
          if(this.color !== color.toHEXA().toString()){
            this.setColorDebounced = debounce(function(){
              this.color = color.toHEXA().toString();
              this.creativeDetail.templates.find((x) => x.id == this.template.id).colorPalette.primaryColor = this.color;
            }, 250);
            this.setColorDebounced();
          }
        });
        this.colorPicker.on('show', (color, instance) => {
          // Post tab switch - when user clicks / when color picker is re-initialized the dialog position is not re-computed correctly,
          // below code will re-compute and assign the position based on the original library implementation
          // Reference: https://github.com/Simonwep/pickr/blob/master/src/js/pickr.js
          let colorPickerDialog = instance._root.app;
          let colorPickeButton = document.querySelector('.color-picker');
          if(colorPickeButton){
            const cb = colorPickeButton.getBoundingClientRect();
            colorPickerDialog.style.top = `${(cb.top)}px`;
            colorPickerDialog.style.left = `${(cb.left + 30)}px`;
          }
        })
        this.colorPicker.setColor(this.creativeDetail.selectedColorPalette.primaryColor);
        window.addEventListener('wheel', this.hideColorPicker, true);
      })
    }
    catch(ex){
      // Later log load errors here if needed
    }
    finally{
      this.animationType = 0;
    }
  }
};
</script>
<style lang="scss" scoped>
.setup-business-info-color .input-border{
  border: solid 0.5px var(--v-error-base) !important;
}
::v-deep .setup-business-info-logo .input-border{
  border: solid 0.5px var(--v-error-base) !important;
}

.button-bg{
background-color: #F5FBFC;
}
.editIconContainer{
cursor: pointer;
}
.editIcon{
  color: #13abb1;
}

.color-picker-container{
  cursor: pointer;
}

.color-picker-container-disabled{
  cursor: not-allowed !important;
  pointer-events: none;
}

.color-picker {
  height: 35px;
  width: 35px;
  cursor: inherit !important
}

.color-picker-code{
  line-height: 2.5;
}

.palette-color {
  height: 20px !important;
  width: 20px !important;
  box-shadow: none !important;
}

.palette-outline{
    border: 2px solid var(--v-primary-base) !important;
}

.color-picker-btn{
    height: auto !important;
    justify-self: right;
    width: fit-content;
    min-width:fit-content !important;
}

::v-deep .input-border{
  border-radius: 4px;
  border: solid 0.5px var(--v-black-base);
  white-space: nowrap !important;
  overflow-x: auto !important;
  scrollbar-width: thin;
}

.text-primary {
    color: var(--v-primary-base);
}

.modal-text{
  font-size: 14px !important;
}

.truncate{
  overflow: hidden;
  max-width: 20ch;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.separator{
 border-right: 1px solid #aaaaaa;
}

.main-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 80px;
}

.scanner-container {
  position: relative;
  width: 420px;
  height: 400px;
  overflow: hidden;
}

.scanner-image {
  width: 350px;
  height: 250px;
  filter: blur(2px);
}

.scanner-line {
  position: absolute;
  top: 0;
  left: 50%;
  width: 380px;
  height: 6px;
  border-radius: 5px;
  background: #474747;
  animation: scan 1s infinite alternate ease-in-out;
  will-change: transform;
  transform: translateX(-50%);
}

@keyframes scan {
  0% {
    transform: translateX(-50%) translateY(0px);
  }

  100% {
    transform: translateX(-50%) translateY(245px);
  }
}
</style>